module.exports = __webpack_public_path__ + "media/stylesheets/images/martech/logo-23-24a35944b8f03db058b1655365618d1f.svg";